import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Snackbar } from '@mui/material';
import { loginUser } from '../Api/loginUser';

function LoginModal({ open, onClose, onSuccessfulLogin, displayUserName }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: '' });
  
  const handleLogin = async () => {
    const loginData = {
      email: email,
      password: password,
    };

    try {

      const result = await loginUser(loginData); // Await the loginUser function
      console.log('Login successful:', result);
      
      const accessToken = result.data.refreshToken; // Replace `token` with the actual key from the API response
      localStorage.setItem('userEmail', result.data.email);
      localStorage.setItem('userName', result.data.userName);
      localStorage.setItem('userId', result.data._id);
      console.log("result", result.data);
      const userData = {
        email: result.data.email,
        userName: result.data.userName,
      };
      localStorage.setItem('userdata', JSON.stringify(userData));
      if (accessToken) {
        localStorage.setItem('accessToken', accessToken);
      }
      setSnackbar({ open: true, message: 'Login successful!', severity: 'success' });
      onSuccessfulLogin('/placeholder.svg?height=40&width=40'); // Pass profile image as a placeholder
      onClose(); // Close the modal
    } catch (error) {
      console.error('Login failed:', error);
      setSnackbar({ open: true, message: error.message || 'Login failed', severity: 'error' });
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Login</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Email Address"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Password"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleLogin}>
            Login
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for feedback */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        message={snackbar.message}
        severity={snackbar.severity}
      />
    </>
  );
}

export default LoginModal;
